import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@aigntx/ui/theme.css";
import "@aigntx/ui/components.css";
import "./app.css";
import App from "./App";

const el = document.getElementById("root");
if (!el) throw new Error("#root not found");
createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Register the service worker in production so the app is installable + offline-capable.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
